import React from "react";
import { Modal, Button } from "react-bootstrap";

import axios from "axios";
import { useDispatch } from "react-redux";
import {actions} from "app/components/Snackbar/snackbarReducer";

export default function UpdateSales({ onHide, show, onGroups, skip, take, orderBy, sortField, filterInputs, isFrozenBySystem }) {
    const dispatch = useDispatch();

    const endpoint = isFrozenBySystem ? "startSales" : "stopSales"
    const onUpdate = (e) => {
        e.preventDefault();

        axios({
            method: "put",
            url: `agents/${endpoint}`,
        })
            .then(() => {
                onGroups({...filterInputs, skip, take, orderBy, sortField});
                dispatch(actions.setSnackbar({message: isFrozenBySystem ? "Satış aktivdir." : "Satış dayandırılmışdır."}))
                onHide();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <form onSubmit={onUpdate}>
                <Modal.Header closeButton>
                    <Modal.Title id="delete">{isFrozenBySystem ? "Satışı aktivləşdir" : "Satışı dayandır"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12 pl-4 pr-4">
                        <div className="row">{isFrozenBySystem ? "Satışı aktivləşdirməyə əminsiniz?" : "Satışı dayandırmağa əminsiniz?"}</div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={() => onHide(false)}>
                        Ləğv
                    </Button>
                    <Button type="submit">Təsdiqlə</Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}
